const weddings = [
  {
    id: 1,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651915/KWP_4374_dj1xhj.jpg",
    alt: "photo-one"
  },
  {
    id: 2,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651914/KWP_4371_vzf6do.jpg",
    alt: "photo-two"
  },
  {
    id: 3,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651915/KWP_4557_i0jicd.jpg",
    alt: "photo-three"
  },
  {
    id: 4,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651914/KWP_3824_wjyoju.jpg",
    alt: "photo-four"
  },
  {
    id: 5,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651904/KWP_3697_grx4kz.jpg",
    alt: "photo-five"
  },
  {
    id: 6,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651903/KWP_3644_l1nc3s.jpg",
    alt: "photo-six"
  },
  {
    id: 7,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651899/KWP_3172_vwdntk.jpg",
    alt: "photo-seven"
  },
  {
    id: 8,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651898/KWP_3117_ctvr5u.jpg",
    alt: "photo-eight"
  },
  {
    id: 9,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651898/KWP_3467_h4lkwy.jpg",
    alt: "photo-nine"
  },
  {
    id: 10,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651885/KWP_1665b_zlapwb.jpg",
    alt: "photo-nine"
  },
  {
    id: 11,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739651978/KWP_8521_mqh8mg.jpg",
    alt: "photo-nine"
  },
  {
    id: 12,
    image: "https://res.cloudinary.com/dqflr6fmv/image/upload/v1739652057/photo21_a1sztv.jpg",
    alt: "photo-nine"
  },
]

export default weddings;